const { API_BASE_URL } = require("../../utils/constants");

module.exports = {
  META_CLIENT_ID: "1889301381171290",
  //   META_REDIRECT_URI: process.env.REACT_APP_SANDBOX_URL + "/meta/auth",
  // META_REDIRECT_URI: "http://localhost:3000/config/ads",
  META_REDIRECT_URI: `${API_BASE_URL}/auth/callback`,
};
